import { render } from "./ModalWrapperXLBodyScroll.vue?vue&type=template&id=e39afb56"
import script from "./ModalWrapperXLBodyScroll.vue?vue&type=script&lang=js"
export * from "./ModalWrapperXLBodyScroll.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__